import { path } from 'ramda';

// eslint-disable-next-line import/prefer-default-export
export const getInstantExperiences = path(['instantExperiences', 'enabled']);
export const getInstantExperiencesOwner = path(['instantExperiences', 'owner']);



// WEBPACK FOOTER //
// ./src/app/instantExperiences/selectors.js